import React, { useState } from 'react';
import { Typography, Box, Button, Container, Paper } from '@mui/material';
import { questionsData, quizNames } from './quizData';
import ReactHtmlParser from 'html-react-parser';
import './quiz-evaluations-nationales.css';

const App = () => {
  const [currentSubject, setCurrentSubject] = useState("");
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [score, setScore] = useState(0);
  const [selectedOption, setSelectedOption] = useState([]);
  const [currentYear, setCurrentYear] = useState("");


  const handleAnswer = (option) => {
    const correctAnswer = questionsData[currentYear][currentSubject][currentQuestion].correctAnswer;
    if (option === correctAnswer) {
      setScore(score + 1);
    }
    setSelectedOption(option);
  };

  const getQuestionScoreAndOptions = (formElements) => {
      const correctAnswer = questionsData[currentYear][currentSubject][currentQuestion].correctAnswer;
      let questionScore = 0;
      let options = [];
      for (let i = 0; i < formElements.length; i++) {
        if (formElements[i].checked === undefined) {
            return [questionScore, options];
        } else {
          if (formElements[i].checked) {
              questionScore += parseInt(formElements[i].value) === correctAnswer[formElements[i].name];
              options.push(parseInt(formElements[i].value));
          }
        }
      }
  }

  const handleSubmit = (event) => {
      event.preventDefault();
      const form = event.target;
      const [questionScore, options] = getQuestionScoreAndOptions(Object.values(form.elements));
      const questionGrade = questionScore / questionsData[currentYear][currentSubject][currentQuestion].correctAnswer.length;
      setScore(score + questionGrade);
      setSelectedOption(options);
  }


  const handleNext = () => {
    const nextQuestion = currentQuestion + 1;
    setCurrentQuestion(nextQuestion);
    setSelectedOption("");
  }

  const handleChoice = (selectedYear, selectedQuiz) => {
    setCurrentYear(selectedYear);
    setCurrentSubject(selectedQuiz);
    setCurrentQuestion(0);
    setScore(0);
    setSelectedOption("");
  };

  const onRestart = () => {
    setCurrentQuestion(0);
    setScore(0);
    setSelectedOption("");
  };

  const onGoToList = () => {
    handleChoice("", "");
  }

  return (
    <Container maxWidth="sm" sx={{ mt: 5 }}>
      {currentSubject.length === 0 ? (
          <>
              <Paper elevation={10}>
                        <>
                            
			    <Typography variant="h5" align="center">
                                Quiz de préparation aux Évaluations Nationales Lycée <font color="red">2nde</font>
                            </Typography>
                            <ul style={{listStyle: 'none', padding: '5px'}}>
                                {Object.entries(quizNames['seconde']).map(name => {
                                    return (
                                        <li key={name[0]}>
                                            <Button
                                                variant="contained"
                                                fullWidth
                                                style={{marginBottom: '5px'}}
                                                onClick={() => handleChoice("seconde", name[0])}>
                                                {name[1]}
                                            </Button>
                                        </li>
                                    );
                                })}
                            </ul>
                        </>
            </Paper>
        </>
      ) : (
          <Paper elevation={10}>
            {currentQuestion < questionsData[currentYear][currentSubject].length ? (
                <>
                    {selectedOption.length === 0 ? (
                        <div style={{ padding: '16px' }}>
                          <Typography variant="h5" gutterBottom>
                            {quizNames[currentYear][currentSubject]}
                          </Typography>
                          {currentSubject === 'francaisComprehension2023' ? (
                              <Typography variant="h7" gutterBottom>
                                {currentQuestion < 10 ? ReactHtmlParser("Support extrait d’Alphonse Daudet, <i>Le Petit Chose<i/>") : "Support : groupement thématique de 3 documents"}
                              </Typography>
                          ) : null}
                          <Typography variant="h6" gutterBottom>
                            {`Question ${currentQuestion + 1} / ${questionsData[currentYear][currentSubject].length}`}
                          </Typography>
                          <Typography variant="body1">
                           {ReactHtmlParser(questionsData[currentYear][currentSubject][currentQuestion]['question'])}
                          </Typography>
                          <div style={{ marginTop: '16px' }}>
                            {!Array.isArray(questionsData[currentYear][currentSubject][currentQuestion]['options'][0]) ? (
                                <>
                                    {questionsData[currentYear][currentSubject][currentQuestion]['options'].map((option, index) => {
                                     return (
                                      <Button
                                        key={index}
                                        variant="outlined"
                                        fullWidth
                                        onClick={() => handleAnswer(index)}
                                        sx={{ marginTop: '8px' }}
                                        style={{ textTransform: 'none' }}
                                      >
                                        {ReactHtmlParser(option)}
                                      </Button>
                                   )})}
                                </>
                            ) : (
                                <form onSubmit={handleSubmit}>
                                    <table align="center" border="1" cellSpacing="0" cellPadding="5">
                                      <tbody>
                                          <tr>
                                            <th/>
                                            <>
                                                {questionsData[currentYear][currentSubject][currentQuestion]['options'][1].map((option, xIndex) => (
                                                    <th key={xIndex}>{ReactHtmlParser(option)}</th>
                                                ))}
                                            </>
                                          </tr>
                                          <>
                                            {questionsData[currentYear][currentSubject][currentQuestion]['options'][0].map((option, yIndex) => (
                                              <tr key={yIndex}>
                                                <th>{ReactHtmlParser(option)}</th>
                                                    {questionsData[currentYear][currentSubject][currentQuestion]['options'][1].map((option, xIndex) => (
                                                        <th key={xIndex}><input type="radio" id={xIndex} name={yIndex} value={xIndex} /></th>
                                                    ))}
                                              </tr>
                                            ))}
                                          </>
                                      </tbody>
                                    </table><br/>
                                    <Box mt={3}>
                                      <Button type="submit" variant="contained" sx={{ marginRight: 2 }}>
                                        Valider
                                      </Button>
                                    </Box>
                                 </form>
                            )}
                          </div>
                          {currentQuestion === 0 ? (
                              <Box mt={3}>
                                <Button variant="contained" onClick={onGoToList}>
                                    Retour à la liste des évaluations
                                </Button>
                              </Box>
                          ) : (
                            null
                          )}
                        </div>
                    ) : (
                        <div style={{ padding: '16px' }}>
                          <Typography variant="h5" gutterBottom>
                            {quizNames[currentYear][currentSubject]}
                          </Typography>
                          {currentSubject === 'francaisComprehension2023' ? (
                              <Typography variant="h7" gutterBottom>
                                {currentQuestion < 10 ? ReactHtmlParser("Support extrait d’Alphonse Daudet, <i>Le Petit Chose<i/>") : "Support : groupement thématique de 3 documents"}
                              </Typography>
                          ) : null}
                          <Typography variant="h6" gutterBottom>
                            {`Réponse ${currentQuestion + 1} / ${questionsData[currentYear][currentSubject].length}`}
                          </Typography>
                          <Typography variant="body1">
                           {ReactHtmlParser(questionsData[currentYear][currentSubject][currentQuestion]['question'])}
                          </Typography>
                          <div style={{ marginTop: '16px' }}>
                            {!Array.isArray(questionsData[currentYear][currentSubject][currentQuestion]['options'][0]) ? (
                                <>
                                    {questionsData[currentYear][currentSubject][currentQuestion]['options'].map((option, index) => (
                                      <Button
                                        key={index}
                                        variant="outlined"
                                        fullWidth
                                        sx={{ marginTop: '8px' }}
                                        color={index === questionsData[currentYear][currentSubject][currentQuestion].correctAnswer ? 'success' : index === selectedOption ? 'error' : 'primary'}
                                        style={{pointerEvents : 'none', textTransform: 'none'}}
                                        disabled={index !== questionsData[currentYear][currentSubject][currentQuestion].correctAnswer && index !== selectedOption}
                                      >
                                        {ReactHtmlParser(option)}
                                      </Button>
                                    ))}
                                </>
                            ) : (
                                <>
                                    <table align="center" border="1" cellSpacing="0" cellPadding="5">
                                      <tbody>
                                          <tr>
                                            <th/>
                                            <>
                                                {questionsData[currentYear][currentSubject][currentQuestion]['options'][1].map((option, xIndex) => (
                                                    <th key={xIndex}>{ReactHtmlParser(option)}</th>
                                                ))}
                                            </>
                                          </tr>
                                          <>
                                            {questionsData[currentYear][currentSubject][currentQuestion]['options'][0].map((option, yIndex) => (
                                              <tr key={yIndex}>
                                                <th>{ReactHtmlParser(option)}</th>
                                                    {questionsData[currentYear][currentSubject][currentQuestion]['options'][1].map((option, xIndex) => (
                                                        <th key={xIndex}><input type="radio" defaultChecked={xIndex === questionsData[currentYear][currentSubject][currentQuestion].correctAnswer[yIndex]} disabled={xIndex !== questionsData[currentYear][currentSubject][currentQuestion].correctAnswer[yIndex]}/></th>
                                                    ))}
                                              </tr>
                                            ))}
                                          </>
                                      </tbody>
                                    </table><br/>
                                </>
                            )}
                          </div>
                          <Box mt={3}>
                            <Button variant="contained" onClick={handleNext} sx={{ marginRight: 2 }}>
                               {currentQuestion < questionsData[currentYear][currentSubject].length - 1 ? "Question suivante" : "Voir le résultat"}
                            </Button>
                          </Box>
                        </div>
                    )}
                </>
            ) : (
                <div style={{ padding: '16px' }}>
                  <Typography variant="h5" gutterBottom>
                    {quizNames[currentYear][currentSubject]}
                  </Typography>
                  <Typography variant="h6" gutterBottom>
                    Résultat
                  </Typography>
                  <Typography variant="body1" id="resultat">
                    {`Vous avez obtenu une note de ${score} / ${currentQuestion} !`}
                  </Typography>
                  <Box mt={3}>
                    <Button variant="contained" onClick={onRestart} sx={{ marginRight: 2 }}>
                        Recommencer
                    </Button>
                    <Button variant="outlined" onClick={onGoToList}>
                        Retour à la liste des évaluations
                    </Button>
                  </Box>
                </div>
            )}
          </Paper>
      )}
    </Container>
  );
};

export default App;
